import React, { useEffect, useState } from "react";
import nominationStyle from "src/Assets/css/Moderator/Nominations.module.css";
import API from "../../../network";
import NominationCard from "./NominationCard";

const Nominations = ({ tenantId }) => {
  const [nominatedUserInfo, setNominatedUserInfo] = useState([]);
  const [nominationsList, setNominationsList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getNominatedtedUserDetails = async () => {
      try {
        setLoading(true);

        const formData = new FormData();
        formData.append("selectedTId", tenantId);

        const response = await API.getAllNominatedtedUserDetails(formData);

        const data = response?.data || {};

        setNominatedUserInfo(data?.nominatedUserInfo || []);
        setNominationsList(data?.nominationsList || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (tenantId) {
      getNominatedtedUserDetails();
    }
  }, [tenantId]);
  
  const handleRemoveNomination = (userId) => {
    setNominatedUserInfo((prev) =>
      prev.filter((user) => user?.mainuserdata?.userid !== userId),
    );
  };

  if (loading) {
    return <p style={{ textAlign: "center", marginTop: "60px" }}>Loading...</p>;
  }

  console.log(`nominatedUserInfo:`, nominatedUserInfo);
  console.log(`nominationsList:`, nominationsList);

  return (
    <div className={nominationStyle.NominationMainContainer}>
      {nominatedUserInfo.length > 0 ? (
        nominatedUserInfo.map((user, index) => (
          <NominationCard
            key={user?.userID || index}
            user={user}
            nominations={nominationsList[index] || []}
            tenantId={tenantId}
            onRemove={handleRemoveNomination}
          />
        ))
      ) : (
        <p>No nominated users found.</p>
      )}
    </div>
  );
};

export default Nominations;
